import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { TimelineLabelType } from '../../../constants/ComponentTypes';
import StatusItem from '../items/StatusItem';

const styles = () => ({
  root: {
    display: 'flex',
    marginBottom: '45px',
  },
});

class StatusList extends React.Component {
  render() {
    const { classes } = this.props;

    // 表示するタイムラインのステータスを設定する
    let items;
    if (this.props.hasKLFollowCallBeenEnabled) {
      items = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.NON_CONNECT,
        TimelineLabelType.DECLINED,
        TimelineLabelType.CONNECT,
        TimelineLabelType.SENT_DOCUMENT,
        TimelineLabelType.APPOINTMENT,
        TimelineLabelType.APPROACH_NG,
        TimelineLabelType.CLOSE,
      ];
    } else {
      items = [
        TimelineLabelType.APPROACH,
        TimelineLabelType.APPOINTMENT,
        TimelineLabelType.APPROACH_NG,
        TimelineLabelType.CLOSE,
      ];
    }

    return (
      <div className={classes.root}>
        {items.map((item, i) => (
          <StatusItem
            item={item}
            pageInfo={this.props.pageInfo}
            handleClick={this.props.handleClick}
            key={i}
            statusSelected={this.props.statusSelected}
          />
        ))}
      </div>
    )
  }
}

StatusList.propTypes = {
  classes: PropTypes.object.isRequired,
  pageInfo: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  hasKLFollowCallBeenEnabled: PropTypes.bool,
  statusSelected: PropTypes.number.isRequired,
};

StatusList.defaultProps = {
  hasKLFollowCallBeenEnabled: false,
};

export default withStyles(styles)(StatusList);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/lists/StatusList.jsx